import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdAssignment, MdCancel, MdAccessTime } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import toast from "react-hot-toast";
import SideBar from "components/Dashboard/SideBar";
import Promos from "components/UserDashboard/Promos";
import Loading from "Util/Loading";
import { setAuthModalOpen } from "store/features/authModalSlice";
import orderApi from "api/order/OrderApi";
import { useNavigate } from "react-router-dom";

function UserProfile() {
  const user = useSelector((state) => state.user?.user);
  const dispatch = useDispatch();

  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  /* ================= CALCULATE STATS ================= */
  const stats = useMemo(() => {
    let total = orders.length;
    let pending = 0;
    let completed = 0;
    let cancelled = 0;

    orders.forEach((o) => {
      if (o.orderStatus === "cancelled") cancelled++;
      else if (o.orderStatus === "completed") completed++;
      else pending++;
    });

    return { total, pending, completed, cancelled };
  }, [orders]);

  /* ================= FETCH ORDERS ================= */
  useEffect(() => {
    if (!user) {
      dispatch(setAuthModalOpen(true));
      return;
    }

    const fetchOrders = async () => {
      try {
        setIsLoading(true);

        const { response, err } = await orderApi.getUserOrders();

        if (response?.data?.orders) {
          setOrders(response.data.orders);
        } else {
          setOrders([]);
        }

        if (err) {
          toast.error(err.message || "Failed to load orders");
        }
      } catch (error) {
        toast.error("Failed to load orders");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrders();
  }, [user, dispatch]);
  const navigate = useNavigate();

  if (isLoading) return <Loading />;
  if (!user) return null;

  /* ================= CARDS ================= */
  const cards = [
    {
      title: "Total ",
      total: stats.total,
      icon: MdAssignment,
      styles: {
        iconBg: "bg-gray-300",
        iconColor: "text-gray-700",
        border: "border-gray-300",
      },
    },
    {
      title: "Pending",
      total: stats.pending,
      icon: MdAccessTime,
      styles: {
        iconBg: "bg-neonYellow/20",
        iconColor: "text-neonYellow",
        border: "border-neonYellow",
      },
    },
    {
      title: "Cancelled ",
      total: stats.cancelled,
      icon: MdCancel,
      styles: {
        iconBg: "bg-red-100",
        iconColor: "text-red-500",
        border: "border-red-300",
      },
    },
    {
      title: "Completed ",
      total: stats.completed,
      icon: AiOutlineCheckCircle,
      styles: {
        iconBg: "bg-green-100",
        iconColor: "text-green-600",
        border: "border-green-300",
      },
    },
  ];
  return (
    <SideBar>
      <div className="space-y-6">
        {/* PROMO */}
        <div className="hidden md:block">
          <Promos />
        </div>

        {/* HEADER */}
        <h2 className="text-2xl font-semibold text-gray-800">
          Order Dashboard
        </h2>

        {/* ================= CARDS ================= */}
        <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              onClick={() => navigate("/dashboard/listoforders")}
              className={`rounded-lg border-2 ${card.styles.border} p-5 flex items-center gap-4 shadow-sm hover:shadow-md transition-all duration-300`}
            >
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center ${card.styles.iconBg}`}
              >
                <card.icon className={`text-lg ${card.styles.iconColor}`} />
              </div>

              <div>
                <p className="text-sm text-gray-500">{card.title}</p>
                <p className="text-xl font-bold text-gray-800">{card.total}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </SideBar>
  );
}

export default UserProfile;

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { MdAssignment, MdCancel, MdCalendarToday } from "react-icons/md";
// import { AiOutlineCheckCircle } from "react-icons/ai";
// import toast from "react-hot-toast";
// import SideBar from "components/Dashboard/SideBar";
// import Table from "components/UserDashboard/Table";
// import Promos from "components/UserDashboard/Promos";
// import { Empty } from "components/UserDashboard/Notifications/Error";
// import bookingApi from "api/booking/BookingApi";
// import Loading from "Util/Loading";
// import { setAuthModalOpen } from "store/features/authModalSlice";

// function UserProfile() {
//   const user = useSelector((state) => state.user?.user);
//   const dispatch = useDispatch();

//   const [orders, setOrders] = useState([]);
//   const [summary, setSummary] = useState({
//     total: 0,
//     cancelled: 0,
//   });

//   const [isLoading, setIsLoading] = useState(false);

//   /* ================= FETCH BOOKINGS ================= */
//   useEffect(() => {
//     if (!user) return;

//     const fetchBookings = async () => {
//       try {
//         setIsLoading(true);
//         const { response } = await bookingApi.getAllBookings();

//         if (response?.data) {
//           const data = response.data;

//           setOrders(data.booking || []);
//           setSummary({
//             total: data.total || 0,
//             cancelled: data.cancelled || 0,
//           });
//         }
//       } catch (error) {
//         toast.error("Failed to load bookings");
//         console.error(error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchBookings();
//   }, [user]);

//   if (isLoading) return <Loading />;

//   /* ================= CALCULATIONS ================= */
//   const now = new Date();

//   const upcomingCount = orders.filter(
//     (b) =>
//       b?.booking?.status === "booked" && new Date(b.selectedDateTime) >= now,
//   ).length;

//   const completedCount = orders.filter(
//     (b) =>
//       b?.booking?.status === "booked" && new Date(b.selectedDateTime) < now,
//   ).length;

//   /* ================= STATUS CARDS ================= */

//   const cards = [
//     {
//       title: "Total Bookings",
//       total: summary.total,
//       icon: MdAssignment,
//       styles: {
//         iconBg: "bg-gray-300",
//         iconColor: "text-gray-700",
//         border: "border-gray-300",
//       },
//     },
//     {
//       title: "Upcoming",
//       total: upcomingCount,
//       icon: MdCalendarToday,
//       styles: {
//         iconBg: "bg-green-100",
//         iconColor: "text-green-600",
//         border: "border-green-400",
//       },
//     },
//     {
//       title: "Cancelled",
//       total: summary.cancelled,
//       icon: MdCancel,
//       styles: {
//         iconBg: "bg-red-100",
//         iconColor: "text-red-500",
//         border: "border-red-300",
//       },
//     },
//     {
//       title: "Completed",
//       total: completedCount,
//       icon: AiOutlineCheckCircle,
//       styles: {
//         iconBg: "bg-gray-300",
//         iconColor: "text-gray-600",
//         border: "border-gray-400",
//       },
//     },
//   ];

//   return (
//     <SideBar>
//       <div className="space-y-6">
//         <div className="hidden md:block">
//           <Promos />
//         </div>

//         <h2 className="text-2xl font-semibold text-gray-800">Dashboard</h2>

//         {/* ================= CARDS ================= */}
//         <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-5">
//           {cards.map((card, i) => (
//             <div
//               key={i}
//               className={`rounded-lg border-2 ${card.styles.border} shadow p-5 flex items-center gap-4 shadow-sm hover:shadow-md transition-all duration-300`}
//             >
//               <div
//                 className={`w-12 h-12 rounded-full flex items-center justify-center ${card.styles.iconBg}`}
//               >
//                 <card.icon className={`text-lg ${card.styles.iconColor}`} />
//               </div>

//               <div>
//                 <p className="text-sm text-gray-500">{card.title}</p>
//                 <p className="text-xl font-bold text-gray-800">{card.total}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </SideBar>
//   );
// }

// export default UserProfile;
